import CreateCustomViewModal from "./custom_views/CreateCustomViewModal";
import EditCustomViewModal from "./custom_views/EditCustomViewModal";
import DeleteCustomViewModal from "./custom_views/DeleteCustomViewModal";

export const coreModals = {
  create_custom_view: CreateCustomViewModal,
  edit_custom_view: EditCustomViewModal,
  delete_custom_view: DeleteCustomViewModal
} as const;

declare module "@mantine/modals" {
  export interface MantineModalsOverride {
    modals: typeof coreModals;
  }
}
